
<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 科目標籤" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
                    <el-button class="mr-2"  @click="openModel(false)" type="primary" size="mini" 
					v-auth="'add'+auth_val">添加科目標籤</el-button>
					
					<!-- <el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量刪除</el-button> -->
				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="科目標籤" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索科目標籤"></el-input>
						</el-form-item>
						
                        <el-form-item label="學科類型"   prop="subject_id">
							<el-select size="small" v-model="from.subject_id">
								<el-option label="全部" value="-1"></el-option>
								<el-option
								v-for="item in subject_list"
								:key="item.id"
								:label="item.name"
								:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>


						<el-form-item label="創建時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							  range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
			
			
                <el-table-column align="center" prop="subject_name" label="所屬科目名稱">
				</el-table-column>

				<el-table-column align="center" prop="label_id" label="對應ID">
				</el-table-column>

				<el-table-column align="center" prop="name" label="科目標籤名稱">
				</el-table-column>

				<el-table-column align="center" prop="create_time" width="200" label="創建時間">
				</el-table-column>
				
                <el-table-column prop="id" align="center" width="140" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="primary" v-auth="'edit'+auth_val" @click="openModel(scope.row)">操作</el-button>
							<el-button @click="deleteItem(scope.row)"  v-auth="'del'+auth_val" size="mini" plain type="danger">刪除</el-button>
						</el-button-group>
					</template>
				</el-table-column>
		
			</el-table>
		</div>

		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>

		<el-dialog :close-on-click-modal="false"  :title="editIndex==-1?'添加科目標籤':'修改科目標籤'" :visible.sync="createModel" 
		top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form :rules="rules" ref="formEdit" :model="form" :label-width="layout.is_phone?'80px':'140px'" :label-position="layout.is_phone?'top':'left'">
               

				<el-form-item label="學科類型"   prop="subject_id">
					<el-select  v-model="form.subject_id">
						<el-option
						v-for="item in subject_list"
						:key="item.id"
						:label="item.name"
						:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="科目標籤名稱" prop="name">
					<el-input type="text" v-model="form.name" 
					placeholder="科目標籤名稱" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>


				<el-form-item label="標籤備註" prop="info">
					<el-input type="textarea" :rows="8" v-model="form.info" 
					placeholder="標籤備註" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>
		

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				rules: {
					name: [{
							required: true,
							message: "名稱不能為空",
							trigger: 'blur',
						},
					],
					info: [{
							required: true,
							message: "標籤備註不能為空",
							trigger: 'blur',
						},
					],
					
				},
                fullscreenLoading: false,
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					info: '',
					time: [],
                    subject_id:'-1',
				},
				model_title: 'TopicLabel',
				auth_val: 'TopicLabel',
				preUrl: "data/TopicLabelList", //列表地址
				delAllUrl: "data/delTopicLabelAll", //批量删除地址
				delUrl: "data/delTopicLabel", //删除單条地址
                addUrl: "data/addTopicLabel", //添加/修改地址
				tableData: [],
				form: {
					id: 0,
					name:'',
					subject_id:null,
				},
				prop: 'subject_id',
				sort: 'ascending',
				total_list: [],
				
				subject_list: [],
				grade_list: [],
			}
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList(['subject_list','grade_list']);
		},
		methods: {
		
			
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					this.subject_list = all.data.list.subject
                    if (this.subject_list.length > 0) {
						// 设置默認选中项为subject_list中的第一个元素
						this.form.subject_id = this.subject_list[0].id;
					}
                   
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			 
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				
				
				this.$refs.formEdit.validate(res => {
					if (res) {
					
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			
		

			// 打开模态框
			openModel(e, type) {
                console.log(e)
				// 修改
				if(e){
					this.form = {
						id:  e.id,
						name: e.name,
						info: e.info,
                        subject_id:e.subject_id,
					}
					this.editIndex = e.id
				}else{
					this.form = {
						id: 0,
						name:'',
						info:'',
                        subject_id:this.form.subject_id,
					}
					this.editIndex = -1
				}
				
				// 打开dialog
				this.createModel = true
			},

			

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name:'',
                    subject_id:'-1',
					time: [],
				}

				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
				}, 1)
			}
		}
	}
</script>

<style>
</style>
